/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CommoditiesResponse,
  CommodityResponse,
  CreateCommoditiesRequest,
  UpdateCommodityByIdRequest,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Commodities<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name GetCommodity
   * @request GET:/commodities/{id}
   * @secure
   */
  getCommodity = (id: string, params: RequestParams = {}) =>
    this.request<CommodityResponse, any>({
      path: `/commodities/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name UpdateCommodity
   * @request PUT:/commodities/{id}
   * @secure
   */
  updateCommodity = (id: string, data: UpdateCommodityByIdRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/commodities/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsCommodities
   * @request OPTIONS:/commodities/{id}
   */
  optionsCommodities = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/commodities/${id}`,
      method: 'OPTIONS',
      ...params,
    });
  /**
   * No description
   *
   * @name GetCommodities
   * @request GET:/commodities
   * @secure
   */
  getCommodities = (params: RequestParams = {}) =>
    this.request<CommoditiesResponse, any>({
      path: `/commodities`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name CreateCommodities
   * @request POST:/commodities
   * @secure
   */
  createCommodities = (data: CreateCommoditiesRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/commodities`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsCommodities2
   * @request OPTIONS:/commodities
   * @originalName optionsCommodities
   * @duplicate
   */
  optionsCommodities2 = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/commodities`,
      method: 'OPTIONS',
      ...params,
    });
}
